import React, { useState } from 'react';
import { Tab, Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import UploadProductContainer from '../../containers/UploadProductContainer/UploadProductContainer';
import UploadHistoryContainer from '../../containers/UploadHistoryContainer/UploadHistoryContainer';
import TopNavbar from '../../components/TopNavBar/TopNavBar';
import AdminPortalSideBar from '../../containers/AdminSideBarContainer/AdminSideBarContainer';
import { Container, TabContent, StyledTabs, BodyWrapper, ContentWrapper } from './UploadpageTab.styles';
import ReviewStagedPanel from '../../components/ReviewStagedPanel/ReviewStagedPanel';
import { listUploadLogs } from '../../api/api';

export default function UploadTabs() {
  const [activeTab, setActiveTab] = useState(0);
  const [reviewOpen, setReviewOpen] = useState(false);
  const [reviewContext, setReviewContext] = useState({ logId: null, readOnly: false });
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  
  const handleChangesDetected = (hasChanges) => {
    setHasUnsavedChanges(hasChanges);
  };

  const handleChange = (_e, newValue) => setActiveTab(newValue);

  const handleUploadComplete = async (logId) => {
    let resolvedId = logId;
    if (!resolvedId) {
      try {
        const logs = await listUploadLogs();
        if (Array.isArray(logs) && logs.length > 0) {
          resolvedId = logs[0].id || logs[0].upload_log_id || null;
        }
      } catch (_) {
      }
    }

    if (resolvedId) {
      setReviewContext({ logId: resolvedId, readOnly: false });
      setReviewOpen(true);
    }
  };

  const handleViewLog = (logId, status) => {
    setActiveTab(1);
    setReviewContext({ logId, readOnly: status === 'complete' });
    setReviewOpen(true);
  };

  const handleClose = (event, reason) => {
    // Prevent closing on backdrop click
    if (reason === 'backdropClick') {
      return;
    }
    
    // Always show confirmation for close button (X button)
    if (reason === 'closeButton' || reason === 'escapeKeyDown') {
      const confirmed = window.confirm('You may lose your changes. Are you sure you want to close?');
      if (!confirmed) {
        return; // Don't close if user cancels
      }
    }
    
    setReviewOpen(false);
    setHasUnsavedChanges(false); // Reset changes flag when closing
  };

  return (
    <Container>
      <TopNavbar onTabChange={() => {}} />
      <BodyWrapper>
        <AdminPortalSideBar />
        <ContentWrapper>
          <StyledTabs
            value={activeTab}
            onChange={handleChange}
            textColor="primary"
            indicatorColor="primary"
          >
            <Tab label="Upload Products" />
            <Tab label="Upload History" />
          </StyledTabs>

          <TabContent>
            {activeTab === 0 && (
              <UploadProductContainer activeTab={activeTab} onUploadComplete={handleUploadComplete} />
            )}
            {activeTab === 1 && (
              <UploadHistoryContainer activeTab={activeTab} onViewLog={handleViewLog} />
            )}
          </TabContent>
        </ContentWrapper>
      </BodyWrapper>

      <Dialog 
        open={reviewOpen} 
        onClose={handleClose} 
        fullWidth 
        maxWidth="lg"
        PaperProps={{
          style: {
            height: '90vh',
            maxHeight: '90vh'
          }
        }}
      >
        <DialogTitle>
          Review Uploaded Products {reviewContext.logId ? `(Log #${reviewContext.logId})` : ''}
          <IconButton onClick={() => handleClose(null, 'closeButton')} sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent 
          dividers 
          style={{ 
            height: 'calc(90vh - 120px)', 
            overflow: 'auto',
            padding: '16px'
          }}
        >
          {reviewContext.logId && (
            <ReviewStagedPanel
              logId={reviewContext.logId}
              readOnly={reviewContext.readOnly}
              onClose={() => handleClose(null, 'closeButton')}
              onChangesDetected={handleChangesDetected}
            />
          )}
        </DialogContent>
      </Dialog>
    </Container>
  );
}
